export default __webpack_public_path__ + "static/media/f78628df-73ed-4524-9ba0-a9b312fbd8c6.b45b99fe.png";